import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./TeamMemberDayTimelineEntry.module.scss";
import {useTeamMemberDayTimelineEntryLogic} from "./TeamMemberDayTimelineEntry.logic";

export interface ITeamMemberDayTimelineEntryProps {
  id: number;
  type: "ChargeCode" | "ServiceTicket";
  duration: number;
  totalDuration: number;
}

export const TeamMemberDayTimelineEntry: VoidFunctionComponent<ITeamMemberDayTimelineEntryProps> = ({id, type, duration, totalDuration}) => {
  const {style} = useTeamMemberDayTimelineEntryLogic(id, type, duration, totalDuration);
  return <div className={s.container} style={{...style}} data-info={JSON.stringify({id, type, duration, style, totalDuration})} >  </div>;
}

